import React from 'react';
import {
  PartialBy,
  DigitalSubmissionChoiceWithText,
  QuestionMultiChoiceWithText,
} from '../../../redux/types';
import ChoiceTextQuestionInput from '../ChoiceTextQuestionInput';
import { QuestionSaveOp } from '../../../hooks/survey/useQuestionSaveStatus';

export type Props ={
  question: QuestionMultiChoiceWithText;
  sectionId?: number;
  enrollmentId?: number;
  caseId?: number;
  disabled?: boolean;
  onSave?: (vals?: PartialBy<DigitalSubmissionChoiceWithText<QuestionMultiChoiceWithText['type']>, 'id'>) => Promise<void>;
  defaultSubmission?: DigitalSubmissionChoiceWithText<QuestionMultiChoiceWithText['type']>;
  expand?: boolean;
  summarizedView?: boolean;
  getSaveStatus?: (op: QuestionSaveOp, qId: number, caseId?: number) => void;
  manualSave?: boolean;
  saveOnBlur?: boolean;
}

const MultiChoiceWithTextQuestionInput: React.FC<Props> = ({
  question,
  sectionId,
  enrollmentId,
  caseId,
  disabled,
  defaultSubmission,
  expand,
  summarizedView: summarized,
  onSave,
  getSaveStatus,
  manualSave,
  saveOnBlur,
}: Props) => (
  <ChoiceTextQuestionInput<QuestionMultiChoiceWithText>
    question={question}
    caseId={caseId}
    sectionId={sectionId}
    enrollmentId={enrollmentId}
    disabled={disabled}
    defaultSubmission={defaultSubmission}
    expand={expand}
    summarizedView={summarized}
    onSave={onSave}
    getSaveStatus={getSaveStatus}
    manualSave={manualSave}
    saveOnBlur={saveOnBlur}
  />
);

export default MultiChoiceWithTextQuestionInput;
